import React from "react";

/**
 * Standard page section with an optional eyebrow / title / subtitle header.
 * `id` doubles as the hash-navigation target.
 */
function Section({ id, eyebrow, title, subtitle, flush = false, children }) {
  const headingId = title ? `${id}-heading` : undefined;

  return (
    <section
      id={id}
      className={`section${flush ? " section--flush" : ""}`}
      aria-labelledby={headingId}
    >
      <div className="container">
        {(eyebrow || title || subtitle) && (
          <header className="section__head">
            {eyebrow && <p className="section__eyebrow">{eyebrow}</p>}
            {title && (
              <h2 id={headingId} className="section__title">
                {title}
              </h2>
            )}
            {subtitle && <p className="section__subtitle">{subtitle}</p>}
          </header>
        )}
        {children}
      </div>
    </section>
  );
}

export default Section;
